import React, { useState } from 'react';
import { Mail, Send, CheckCircle } from 'lucide-react';
import '../styles/Contact.css';
import emailjs from "emailjs-com";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
  e.preventDefault();

  console.log("Gönderiliyor...", formData);

  emailjs.send(
      "service_n3687co",   // + işareti olmayacak
      "template_ehqjz6e",
      {
        name: formData.name,
        email: formData.email,
        subject: formData.subject,
        message: formData.message,
      },
      "MRKDlq7a9cjf1nX9I"  // Public key doğru olmalı
    )
    .then((result) => {
        console.log("Mail gönderildi:", result);
        setSubmitted(true);
    })
    .catch((error) => {
        console.error("Hata:", error);
        alert("Mesaj gönderilemedi. Lütfen bilgileri kontrol edin.");
    });
  };

  return (
    <section id="contact" className="contact-section">
      <div className="contact-container">
        <div className="contact-header">
          <div className="section-badge">
            <span>İLETİŞİM</span>
          </div>
          <h2 className="section-title display-large">İletişime Geçin</h2>
          <p className="section-description body-medium">
            Projemiz hakkında daha fazla bilgi almak veya işbirliği fırsatlarını 
            değerlendirmek için bizimle iletişime geçin.
          </p>
        </div>
        
        <div className="contact-content">
          <div className="contact-info">
            <div className="info-card">
              <div className="info-icon">
                <Mail size={32} />
              </div>
              <div className="info-details">
                <h3 className="heading-3">E-posta</h3>
                <a href="mailto:info@reverard.com" className="info-link body-medium">
                  info@reverard.com
                </a>
              </div>
            </div>
            
            <div className="info-text">
              <p className="body-medium">
                Sorularınızı veya proje ile ilgili taleplerinizi bize ileterek, 
                en kısa sürede size dönüş sağlayacağız.
              </p>
            </div>
          </div>
          
          <div className="contact-form-wrapper">
            {submitted ? (
              <div className="success-message">
                <CheckCircle size={48} />
                <h3 className="heading-2">Teşekkürler!</h3>
                <p className="body-medium">Mesajınız başarıyla gönderildi. En kısa sürede size döneceğiz.</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="contact-form">
                <div className="form-group">
                  <label htmlFor="name" className="form-label body-small">Ad Soyad</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="form-input"
                    required
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="email" className="form-label body-small">E-posta</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="form-input"
                    required
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="subject" className="form-label body-small">Konu</label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    className="form-input"
                    required
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="message" className="form-label body-small">Mesaj</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    className="form-textarea"
                    rows="6"
                    required
                  ></textarea>
                </div>
                
                <button type="submit" className="btn-primary submit-btn">
                  Gönder
                  <Send size={20} />
                </button>
              </form>
            )}
          </div>
        </div>
        
        <footer className="site-footer">
          <div className="footer-content">
            <div className="footer-logo">
              <h3 className="heading-2">REVERA</h3>
              <p className="body-muted">Geleceğin radar teknolojisi</p>
            </div>
            <div className="footer-info">
              <p className="body-small">&copy; 2025 Revera. Tüm hakları saklıdır.</p>
            </div>
          </div>
        </footer>
      </div>
    </section>
  );
};

export default Contact;
